module.exports = __webpack_public_path__ + "static/media/Tablet.7eaa9a32.jpg";